import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import router from './router'
import './icons'
import { installAutocompleteGuard } from './utils/autocompleteGuard'
import { useRelayMediaCatalog } from './services/pipelineAPI'
Vue.use(ElementUI);
Vue.prototype.$bus = new Vue()
Vue.config.productionTip = false
installAutocompleteGuard(router)

// Matrix user-facing image/video creators share the same live model directory
// as the video site.  The pipeline API keeps this opt-in so admin and legacy
// callers can still request their own catalog explicitly.
useRelayMediaCatalog()

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
